import { InputAdornment, TextField } from "@mui/material";
import { useState, ReactElement, HTMLAttributes, useRef, useEffect } from "react";
import { Cancel, DangerSquare, Star } from "../../assets";
import { fixNumbers, numberWithCommas } from "../../core/utils";
import CustomModal from "./modal";
interface Props extends HTMLAttributes<HTMLElement> {
    value?: string | number;
    title?: string,
    onChange?: any;
    myStyle: string;
    icon?: ReactElement;
    customFocus?: any;
    lable?: string;
    disabled?: boolean;
    error?: string;
    type?: string;
    emptyState?: any;
    max?: string;
    placeholder?: string;   
    endAdornment?: string;
    isRequired?:boolean;
    hideEndAdornment?:boolean;
    iconBorder?: boolean;
    hasNotice?: string;
    hasComma?: boolean;
    contentLoading?:boolean;
    hideWhenDisabled?: boolean; 
}

export function Input({ value = "" , onChange, title, myStyle,hideWhenDisabled, icon, customFocus, lable, disabled, error, type, emptyState, hasComma, max, placeholder, iconBorder, endAdornment, isRequired, hideEndAdornment, hasNotice , contentLoading }: Props, props: any): ReactElement | null {
    const inputRef : any = useRef(null);
    const [shrink, setShrink] = useState(false);
    const [selectionStart, setSelectionStart] = useState();
    const [openModal, setOpenModal] = useState(false); // مدیریت نمایش مدال
    const updateSelectionStart = () =>
    setSelectionStart(inputRef.current.selectionStart);

    const setFoces = () => {
        setShrink(true)
        // customFocus && customFocus()
    }

    useEffect(() => {
        if (value === "") {
            setShrink(false);
        } else {
            setShrink(true);
        }
    }, [value]);
    const handleOnChange = (e: any) => {
        const re = /^[0-9\b]+$/;
        const checkLength = new RegExp(`^\\d{0,${max ? max : "255"}}$`);
        let inputValue = fixNumbers(e.target.value); 
        if (type === "number") {
            if (hasComma) {
                let val = inputValue.replace(/,/g, '');
                if ((val === "" || re.test(val)) && checkLength.test(val)) {

                    onChange(val)

                }
            } else {
        
            if ((inputValue === "" || re.test(inputValue)) && checkLength.test(inputValue)) {
                onChange(inputValue)
                }
            }
        } else {
            onChange(e.target.value);
        }
    };

    const displayValue = () => {
        if (type === "number" && hasComma && value !== "") {
            return numberWithCommas(String(value));
        }
        return value;
    };
    if (disabled && hideWhenDisabled) {
        return null; 
    }

    return (
        <div className={`${myStyle && myStyle} custom-input`}>
           {lable && (
                  <>
                    {contentLoading ? (
                        <div className="input-loading-lable content-loading"></div>
                    ) : (
                <label className="custom-input-lable">
                  {isRequired && <img src={Star} alt="هامرز"/>} {lable}{" "}
                  {hasNotice && ( 
                     <img
                         src={DangerSquare}
                         alt="هامرز"
                         style={{ cursor: "pointer" }}
                         onClick={() => setOpenModal(true)} // باز کردن مدال
                     />
                  )} 
                </label>
                    )}
                </>
            )}

            {contentLoading ? (
                <div className="content-loading w-100"></div>
            ) : (
            <TextField
                autoComplete="off"
                className="input"
                // error={!!error}
                value={displayValue()}
                // onChange={(e)=>onChange(e.target.value)}
                onChange={handleOnChange}
                disabled={disabled}
                inputRef={inputRef}
                // onFocus={updateSelectionStart}
                onBlur={(e) => setShrink(!!e.target.value)}
                InputLabelProps={{ sx: icon ? { ml: 4.5 } : null, shrink }}
                sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                        px: icon ? 5.5 : "",
                    }
                }}
                // onInput={(e:any) => {
                //     e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 12);
                //   }}
                //   InputProps={{ inputProps: { min: "0", max: "10", step: "1" } }}
                inputProps={{
                    maxLength: max || "255",
                }}
                // type={type}
                // label={title}
                type="string"
                label={title && title}
                placeholder={placeholder}

                InputProps={{
                    startAdornment: icon ? (
                        <InputAdornment position="start">
                            {icon}
                            {iconBorder && <div className="custom-input-icon-border"></div>}
                        </InputAdornment>
                    ) : null,
                    endAdornment: value && !hideEndAdornment ? (
                        <InputAdornment
 position="end"
 onClick={emptyState}
 className="custom-input-cancel"
>
                            <Cancel width="10px" color="#155a9e" myStyle="cursor-pointer" />
                        </InputAdornment>
                    ) : endAdornment ? (
                            <span>{endAdornment}</span>
                    ) : null,
                }}
                variant="outlined"
            />
            )}
            {error &&
                <label className="custom-input-error">
                    {error}
                </label>
            }
            <CustomModal myStyle="custom-input-modal" openModal={openModal} onClose={() =>setOpenModal(!openModal )}>
          <>
            <div className="custom-modal-main-title hide-desktop">
              <h1 className="title">
              {lable}              </h1>
              <Cancel myStyle="ps-2 " width="20" height="20" color="#000000" onClick={() =>setOpenModal(!openModal )} />
            </div>
            <div className="filter-selected">
              <div>
                <span className="text ml-50 hide-mobile bold">
                {lable}
                </span>{" "}
              </div>
              <Cancel myStyle="hide-mobile cursor-pointer" onClick={() =>setOpenModal(!openModal )} />
            </div>
            
            <h2 className="custom-input-modal-info mt-33">
           {hasNotice}
            </h2>
             
          </>
        </CustomModal>
        </div>
    );
}

export default Input;